// @flow

//
// React
//
import React from 'react';

//
// Formatter
//
import { fmtNumber } from '../../../../trix-web-data-commons';

//
// Components
//
import FloatPaneField from './FloatPaneField';

//
// Props
//
type Props = {
    //
    // State
    //
    fmt?: string,
    label: string,

    //
    // Data
    //
    value: number,

    //
    // Actions
    //
    onClick?: () => void;
}; // End of Props

//
// Component
//
const NumberFloatPaneField = (props: Props): any => {
    const value = fmtNumber(props.value, props.fmt ? props.fmt : '0000000000');

    return(
        <FloatPaneField
            label={props.label}
            value={value}
            onClick={props.onClick}
        />
    );
};
export default NumberFloatPaneField;
